import React from 'react';
import { Input, Label } from 'reactstrap';
import VehicleDamageForm from '../../Common/VehicleDamageForm';

const DamageSection = ({
  danos,
  sinDanos,
  sucio,
  onDamagesChange,
  onSinDanosChange,
  onSucioChange,
  error,
}) => {
  return (
    <>
      <div className="row">
        <div className="col-6">
          <Label for="sin_danos">Sin daños aparentes</Label>
        </div>
        <div className="col-6">
          <Input
            type="checkbox"
            id="sin_danos"
            name="sin_danos"
            checked={sinDanos}
            onChange={onSinDanosChange}
          />
        </div>
      </div>

      {!sinDanos && error && (
        <div className="text-danger small mb-2 mt-2">{error}</div>
      )}
      <div style={{ display: sinDanos ? 'none' : 'block' }}>
        <div className="d-flex align-items-center my-2">
          <div className="flex-grow-1 border-top"></div>
          <span className="mx-3 text-muted fw-bold">Daños</span>
          <div className="flex-grow-1 border-top"></div>
        </div>
        <VehicleDamageForm
          danos={danos}
          onDanosChange={onDamagesChange}
        />
      </div>

      <div className="row">
        <div className="col-6">
          <Label for="sucio">Vehículo sucio</Label>
        </div>
        <div className="col-6">
          <Input
            type="checkbox"
            id="sucio"
            name="sucio"
            checked={sucio}
            onChange={onSucioChange}
          />
        </div>
      </div>
    </>
  );
};

export default DamageSection;
